import styled from '@emotion/styled'
import { headline, mixins, Primary } from '@sphinx/components-styles'
import PageErrorImageSrc from '../../assets/PageError.svg'

export const PageErrorBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const PageErrorBanner = styled.div`
  background-image: url(${PageErrorImageSrc});
  background-repeat: no-repeat;
  background-size: cover;
  height: 236px;
  width: 360px;
`

export const PageErrorMessage = styled.p`
  ${headline};
  position: relative;
  color: ${Primary.navy[100]};
  text-align: center;
  max-width: 65%;
`

export const PageErrorDescription = styled.p`
  ${mixins.body}
  color: ${Primary.navy[100]};
  max-width: 80%;
`

export const PageErrorChildContainer = styled.div`
  margin-top: 24px;
`
